import React, { Dispatch, FC, RefObject, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

import { StyledAccount } from "./SidebarAccount.styled";
import SidebarAccountPopover from "./components/SidebarAccountPopover";

import { USER_ROLE_VALUES } from "@type/User";
import IconUserThumbnail from "@icons/UserThumbnail";
import { useSidebarStateStore } from "@store/sidebar";
import { Button, Stack, Typography } from "@components/base";
import { useUserStore } from "@store/user";

interface SidebarAccount {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  anchorEl: RefObject<HTMLButtonElement>;
}

const SidebarAccount: FC<SidebarAccount> = ({ open, setOpen, anchorEl }) => {
  const { t } = useTranslation();
  const { sidebarCollapsed } = useSidebarStateStore();
  const { user } = useUserStore();

  return (
    <>
      <StyledAccount
        sx={({ spacing }) => ({
          transition: "padding 0.5s",
          paddingLeft: sidebarCollapsed ? spacing(1) : spacing(2),
          paddingRight: sidebarCollapsed ? spacing(1) : spacing(2),
        })}
        ref={anchorEl}
      >
        <Button
          fullWidth
          startIcon={<IconUserThumbnail />}
          onClick={() => setOpen(true)}
          sx={{
            minWidth: 0,
            justifyContent: "center",

            "& .MuiButton-startIcon": {
              transition: "margin 0.5s",
              marginRight: sidebarCollapsed ? 0 : undefined,
              marginLeft: sidebarCollapsed ? 0 : undefined,
            },
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width={sidebarCollapsed ? 0 : "100%"}
            sx={{
              transition: "all 0.5s",
              opacity: sidebarCollapsed ? 0 : 1,
            }}
          >
            <Stack alignItems="start">
              <Typography noWrap>
                {user?.firstName} {user?.lastName}
              </Typography>
              <Typography variant="caption" noWrap>
                {t(`roles.${USER_ROLE_VALUES[user?.role || 0]}`)}
              </Typography>
            </Stack>
            <FeatherIcon icon="more-vertical" size={16} />
          </Stack>
        </Button>
      </StyledAccount>
      <SidebarAccountPopover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorEl}
      />
    </>
  );
};

export default SidebarAccount;
